<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'dinner',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>